import Vue from 'vue'
//vantui 挂载
import {
  Loading,
  Row,
  Col,
  Button,
  Tabbar,
  TabbarItem,
  Image,
  Progress,
  CountDown,
  Search,
  Icon,
  Collapse,
  CollapseItem,
  Form,
  Field,
  Area,
  Popup,
  RadioGroup,
  Radio,
  NavBar,
  Uploader,
  Swipe,
  SwipeItem,
  DatetimePicker,
  Picker,
  Tab,
  Tabs,
  Dialog,
  Grid,
  GridItem,
  PullRefresh,
  Cell,
  CellGroup,
  Switch,
  Overlay,
  List,
  Notify,
  Checkbox,
  CheckboxGroup,
  Calendar,
  DropdownMenu,
  DropdownItem,
  Empty,
  Sticky,
  Toast,
  Popover,
  NoticeBar,
  ActionSheet
} from 'vant'

Vue.use(Loading)
Vue.use(Row).use(Col)
Vue.use(Button)
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Image)
Vue.use(Progress)
Vue.use(CountDown)
Vue.use(Search)
Vue.use(Icon)
Vue.use(Collapse).use(CollapseItem)
Vue.use(Form)
Vue.use(Field)
Vue.use(Area)
Vue.use(Popup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(NavBar)
Vue.use(Swipe).use(SwipeItem)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(Uploader)
Vue.use(Tab).use(Tabs)
Vue.use(Dialog)
Vue.use(Grid).use(GridItem)
Vue.use(PullRefresh)
Vue.use(Cell).use(CellGroup)
Vue.use(Switch)
Vue.use(Overlay)
Vue.use(List)
Vue.use(Notify)
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Calendar);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(Sticky);
Vue.use(Toast);
Vue.use(Popover);
Vue.use(NoticeBar);
Vue.use(ActionSheet);

Dialog.setDefaultOptions({
  confirmButtonColor: '#FF6B31'
});